import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import CreatableSelect from "react-select/lib/Creatable";
import {
    Control,
    ValueContainer,
    MenuSimpleArr as Menu,
    valueRendererSortable as MultiValue,
} from "../../../ReactSelectMaterial/Suggestions";
import {valueHandlerForStringArray} from "./../../FormDynamic/Utils/valueHandler";


const styles = () => ({
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        ['@media (max-height: 650px)']: { // eslint-disable-line no-useless-computed-key
            maxHeight: 150,
            overflowY: 'scroll',
        },
        ['@media (max-height: 590px)']: { // eslint-disable-line no-useless-computed-key
            maxHeight: 100,
            overflowY: 'scroll',
        },
    },
    paper: {
        position: 'absolute',
        zIndex: 9999999,
        overflow: 'hidden',
        left: 0,
        right: 0,
    },
});


class TypeStringArray extends Component {

    renderField = () => {
        const {classes, element, path, values, onChange} = this.props;
        let arrayValues = [];
        arrayValues = valueHandlerForStringArray(values, path, arrayValues);
        const customStyles = {
            dropdownIndicator: () => ({
                display: 'none'
            }),
            indicatorSeparator: () => ({
                display: 'none'
            }),
            clearIndicator: () => ({
                display: 'none'
            }),
            menuPortal: base => ({...base, zIndex: 9999})
        };
        return (
            <CreatableSelect
                menuPortalTarget={document.body}
                styles={customStyles}
                swapItems={() => {}}
                classes={classes}
                isMulti
                fullWidth
                onChange={(newValue) => onChange(newValue, path, element.trackChange)}
                value={arrayValues}
                components={{
                    DropdownIndicator: null,
                    Menu,
                    Control,
                    ValueContainer,
                    MultiValue
                }}
            />
        )
    };

    render() {
        return (
            this.renderField()
        );
    }

}

TypeStringArray.propTypes = {
    element: PropTypes.object.isRequired,
    path: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.any.isRequired
};

export default withStyles(styles)(TypeStringArray);